import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BtnsForGridComponent } from './btns-for-grid.component';
import { BtnsForGridService } from './btns-for-grid.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [BtnsForGridComponent],
  exports: [BtnsForGridComponent],
  providers: [BtnsForGridService]
})
export class BtnsForGridModule { }



// WEBPACK FOOTER //
// ./src/app/utils/btns-for-grid/btns-for-grid.module.ts